export default "__VITE_PUBLIC_ASSET__e56eb2a8__"